import { render, staticRenderFns } from "./ContentStaticProviderMore.vue?vue&type=template&id=37fc8358&scoped=true&"
import script from "./ContentStaticProviderMore.vue?vue&type=script&lang=js&"
export * from "./ContentStaticProviderMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fc8358",
  null
  
)

export default component.exports